var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossinline = function SvgCrossinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    fillRule: "evenodd",
    d: "M.657.643c.21-.21.55-.21.76 0l12.926 12.952a.54.54 0 0 1 0 .762c-.21.21-.55.21-.76 0L.656 1.405a.54.54 0 0 1 0-.762",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    fillRule: "evenodd",
    d: "M.657 14.357a.54.54 0 0 1 0-.762L13.582.643c.21-.21.55-.21.76 0a.54.54 0 0 1 0 .762L1.418 14.357c-.21.21-.55.21-.76 0",
    clipRule: "evenodd"
  })));
};
export default SvgCrossinline;